<template>
  <vx-card no-shadow>
    <!--vs-input
      class="w-1/4 mb-base"
      label="Senha atual"
      v-model="old_password"
    /-->
    <vs-input
      class="w-1/4 mb-base"
      label="Nova senha"
      v-model="new_password"
    />
    <vs-input
      class="w-1/4 mb-base"
      label="Confirmar nova senha"
      v-model="confirm_new_password"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        :disabled="
          new_password != confirm_new_password || new_password.length < 6
        "
        class="ml-auto mt-2"
        @click="saveData"
        >Salvar alterações</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  methods: {
    async saveData() {
      await this.$vs.loading();
      try {
        this.$http.post(`updatePassword`, {
          senha: this.new_password,
        });
        this.$vs.notify(this.$notify.Success);
        this.$emit("done");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
};
</script>
